<template>
  <div class="form-group">
    <label>{{ __("forms.EmailTemplates.wapp_template_message_id") }}</label>
    <select class="form-control" v-model="wapp_template_message_id" v-on:change="loadTemplate()" required :name=name>
        <option v-for="wappTemplateMessage in wapp_template_messages" v-bind:key="wappTemplateMessage.id" :value=wappTemplateMessage.id>
            {{ wappTemplateMessage.name }}
        </option>
    </select>

    <div v-if="this.wapp_template_selected != null">    
        <table>
            <thead>
                <tr>
                    <th style="width: 50px">{{ __('misc.nr_tag') }}</th>
                    <th>{{ __('misc.value_tag') }}</th>
                </tr>
            </thead>
            <tbody>                
                <tr v-for="variable in wapp_template_selected.variables" v-bind:key="variable.id">
                    <td>{{ variable['id'] }}</td>
                    <td>{{ variable['name'] }}</td>
                </tr>                
            </tbody>
        </table>
    </div>

    <div style="border: 1px solid rgb(212, 212, 212); padding: 5px;" v-if="wapp_template_selected != null" v-html="wapp_template_selected.body">        
    </div>

  </div>
</template>
  <script>
export default {
   mounted() {    
    this.wapp_template_message_id = this.ext_wapp_template_message_id;    
    this.loadTemplate();
  },
  props: {
    name: {
        type: String,
        required: true,        
    },
    ext_wapp_template_message_id: {
      type: Number,
      required: false,
      default: null
    },
    wapp_template_messages: {
        type: Array,
        required: false,
        default: []
    }
  },
  data() {
    return {
        wapp_template_message_id: null,
        wapp_template_selected: null
    };
  },
  methods: {
    loadTemplate() {          
        if (this.wapp_template_message_id != null && this.wapp_template_message_id !== undefined){
            
            let svc = this;
            this.wapp_template_selected = this.wapp_template_messages.filter(function(item) {
              return item["id"] == svc.wapp_template_message_id;
            })[0];

            this.wapp_template_selected.body = this.wapp_template_selected.body.replace(/\n/g, '<br>');
        } else { 
            this.wapp_template_selected = null;
        }
    },
  },
};
</script>